import { getCurrentInstance, onActivated, onDeactivated, onScopeDispose, toValue } from 'vue';
import { subscribeAttendanceRefresh } from '@/utils/attendanceSync';

/** Refresh an active screen after bot changes, browser resume or application writes. */
export function useAttendanceSync(callback, { enabled = true } = {}) {
  let active = true;
  const subscription = subscribeAttendanceRefresh(callback, { enabled: () => active && toValue(enabled) !== false });
  if (getCurrentInstance()) {
    onDeactivated(() => { active = false; });
    onActivated(() => {
      const resumed = !active;
      active = true;
      if (resumed) void subscription.refresh();
    });
  }
  onScopeDispose(subscription.stop);
  return subscription;
}
